import { Build, Env, setMode } from '@stencil/core';

const tenantMode = Env.tenantEnv || 'hornbach';

const tenantModeMapping = {
  hornbach: 'hb',
  bodenhaus: 'boh',
};

const getTenantMode = () => {
  if (!tenantMode) {
    return;
  }
  return tenantModeMapping[tenantMode];
};

export default async () => {
  if (!Build.isServer) {
    setMode(getTenantMode);
  }
};